import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-auto"
}
const _hoisted_2 = { class: "p-inputgroup p-0 position-relative mt-auto pt-3" }
const _hoisted_3 = { class: "p-float-label hiding position-absolute" }
const _hoisted_4 = { class: "p-floating-label" }
const _hoisted_5 = {
  key: 1,
  class: "p-float-label w-100 mt-3"
}
const _hoisted_6 = {
  key: 0,
  class: "p-inputgroup"
}
const _hoisted_7 = { class: "p-float-label w-100 mt-3 d-flex" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cursor" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "p-inputgroup p-0 position-relative pt-3"
}
const _hoisted_11 = { class: "p-float-label hiding position-absolute" }
const _hoisted_12 = { class: "p-floating-label" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gear" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_ctx.property.format === 'modal' || _ctx.property.format === 'style')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t( 'editor.style' )), 1)
          ]),
          _createVNode(_component_Dropdown, {
            modelValue: _ctx.currValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currValue) = $event)),
            options: _ctx.property.format === 'modal' ? _ctx.getStyleOptions() : _ctx.getModalOptions(),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateConfig()))
          }, null, 8, ["modelValue", "options"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        (!_ctx.property.preDefined || _ctx.mode === _ctx.EditMode.Advanced)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_InputNumber, {
                  class: _normalizeClass(["w-100", _ctx.property.preDefined? 'p-inputgroup-not-last': '' ]),
                  modelValue: _ctx.currValue,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currValue) = $event)),
                  mode: _ctx.getNumberMode(_ctx.property.format),
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateConfigVal( $event.value)))
                }, null, 8, ["modelValue", "mode", "class"]),
                _createElementVNode("label", null, _toDisplayString(_ctx.$t( 'editor.' + (_ctx.property.label ? _ctx.property.label : _ctx.id) )), 1),
                (_ctx.property.preDefined)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "p-inputgroup-addon flex-grow-0 border-start-0",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeMode && _ctx.changeMode(...args)))
                    }, _hoisted_9))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t( 'editor.' + (_ctx.property.label ? _ctx.property.label : _ctx.id) )), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.property.preDefined, (preDef) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: _normalizeClass(["p-inputgroup-addon flex-grow-1 cursor-pointer", preDef.value === _ctx.currValue ? 'bg-light':'']),
                  onClick: ($event: any) => (_ctx.updateConfigVal(preDef.value)),
                  key: preDef
                }, [
                  _createVNode(_component_Icon, {
                    icon: preDef.icon
                  }, null, 8, ["icon"])
                ], 10, _hoisted_13))
              }), 128)),
              (_ctx.property.preDefined)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "p-inputgroup-addon flex-grow-0",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeMode && _ctx.changeMode(...args)))
                  }, _hoisted_15))
                : _createCommentVNode("", true)
            ]))
      ]))
}